import React from "react";
import "./style.css";

const Skeleton = ({ className = "", style }) => (
    <div className={`skeleton ${className}`} style={style} />
);

export default Skeleton;
